import { Action, createReducer, on } from '@ngrx/store'
import {
  fetch_announcement_details_success,
  load_announcement_summary_success_action
} from '../action/announcement.action'
import { AnnouncementState, initialAnnouncementState } from '../state/announcement.state'

export function announcementReducer(state: AnnouncementState, action: Action) {
  return _announcementReducer(state, action)
}

export const _announcementReducer = createReducer(
  initialAnnouncementState,
  on(load_announcement_summary_success_action, (state, { announcement }) => {
    return {
      ...state,
      summary: announcement
    }
  }),
  on(fetch_announcement_details_success, (state, { announcement }) => {
    return {
      ...state,
      details: announcement
    }
  })
)
